import { pathnameChecker } from 'utils/url';

/**
 * Đổi khu vực chỉ cần nạp lại dữ liệu, không cần nạp lại cả trang: `getHeaders`
 * đọc `localStorage.getItem('region')` ngay lúc gửi request, nên mọi request sau
 * khi ghi localStorage đã tự đúng khu vực.
 *
 * Trang có mặt ở đây phải TỰ lắng nghe `REGION_CHANGED` và fetch lại. Trang chưa
 * có listener thì vẫn phải `reloadAfterPaint()` — bỏ reload mà quên listener sẽ
 * để lại giá của khu vực cũ.
 */
export default function regionRefreshInPlace(pathname: string): boolean {
  if (!pathname) {
    return false;
  }
  if (pathnameChecker.isOtherPage(pathname, '/checkout')) {
    return false;
  }
  return (
    pathnameChecker.isHomePage(pathname) ||
    pathnameChecker.isProductPage(pathname) ||
    pathnameChecker.isMarketRoutes(pathname) ||
    pathnameChecker.isOtherPage(pathname, '/cart')
  );
}
